var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:page-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.8346 15.5V7.42577C25.8347 7.32381 25.8147 7.22284 25.7757 7.12864C25.7367 7.03444 25.6794 6.94886 25.6073 6.87681L21.5411 2.81065C21.3959 2.66526 21.1989 2.58349 20.9935 2.58331H5.94297C5.73743 2.58331 5.5403 2.66496 5.39496 2.81031C5.24962 2.95565 5.16797 3.15277 5.16797 3.35831V27.6416C5.16797 27.8472 5.24962 28.0443 5.39496 28.1897C5.5403 28.335 5.73743 28.4166 5.94297 28.4166H14.2096M10.3346 12.9166H20.668M10.3346 7.74998H15.5013M10.3346 18.0833H14.2096M23.1919 21.8808L24.4836 20.5891C24.618 20.4546 24.7777 20.3478 24.9535 20.275C25.1292 20.2021 25.3176 20.1646 25.5078 20.1646C25.6981 20.1646 25.8865 20.2021 26.0622 20.275C26.238 20.3478 26.3977 20.4546 26.5321 20.5891C26.8035 20.8607 26.956 21.2289 26.956 21.6128C26.956 21.9967 26.8035 22.3649 26.5321 22.6364L25.2405 23.9281L23.1919 21.8795L19.3285 25.7429C19.1353 25.9367 19.0087 26.1868 18.9668 26.4572L18.6517 28.4683L20.6628 28.1544C20.9332 28.1126 21.1833 27.9859 21.3771 27.7928L25.2392 23.9281",
    stroke: "#4A4A4A",
    strokeWidth: 1.68,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.668 2.58331V6.97498C20.668 7.18052 20.7496 7.37765 20.895 7.52299C21.0403 7.66833 21.2374 7.74998 21.443 7.74998H25.8346",
    stroke: "#4A4A4A",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingManagement);
export default __webpack_public_path__ + "static/media/booking-management.9da2ce0cd060174c5f07a1275ead6af4.svg";
export { ForwardRef as ReactComponent };